import React from "react";
import { Platform } from "react-native";
import { createStackNavigator } from "@react-navigation/stack";
import { useApplicationRelevantStorageInformation } from "../../hooks/useApplicationRelevantStorageInformation";
import { SignInScreen } from "../../screens/unauthed/sign-in";
import { SelectPropertyScreen } from "../../screens/unauthed/select-property";
import { SignUpScreen } from "../../screens/unauthed/sign-up";
import { SignUpConfirmedScreen } from "../../screens/unauthed/sign-up-confirmed";
import { Header } from "../../components/new/header/header";
import { translate } from "../../i18n";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";
import { ForgotPassword } from "../../screens/unauthed/forgot-password";
import { ActionRequired } from "../../screens/unauthed/action-required";

const Stack = createStackNavigator();

export function UnauthedStack() {
  const hasSeenIntro = useSelector(
    (state: RootState) => state.auth.applicationRelevantStorageInformation.hasSeenIntro
  );
  return (
    <Stack.Navigator
      screenOptions={{ headerMode: "screen", omitProfileIcon: false, showFullMenu: false }}
      initialRouteName={getInitialRouteName({ hasSeenIntro })}>
      <Stack.Screen
        name="SignIn"
        component={SignInScreen}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          omitTitleHeader: true,
        })}
      />
      <Stack.Screen
        name="SelectProperty"
        component={SelectPropertyScreen}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          title: translate("authStack.searchProperty") as string,
          omitRightContent: true,
          useLight: true,
        })}
      />
      <Stack.Screen
        name="SignUp"
        component={SignUpScreen}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          omitTitleHeader: true,
        })}
      />
      <Stack.Screen
        name="SignUpConfirmed"
        component={SignUpConfirmedScreen}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          omitTitleHeader: true,
        })}
      />
      <Stack.Screen
        name="ForgotPassword"
        component={ForgotPassword}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          omitTitleHeader: true,
        })}
      />
      <Stack.Screen
        name="ActionRequired"
        component={ActionRequired}
        options={({ route }) => ({
          header: (props) => <Header {...props} />,
          omitTitleHeader: true,
        })}
      />
    </Stack.Navigator>
  );
}

export interface UnauthedParamsList extends Record<string, any> {}

export type UnauthedScreenProps = {
  route: { name: string; key: string; params: UnauthedParamsList };
};

const getInitialRouteName = ({ hasSeenIntro }: Partial<Record<string, boolean>>) => {
  // Real Logic
  return hasSeenIntro ? "SignIn" : "Walkthrough";
};
